import { takeLatest, put, call } from 'redux-saga/effects';
import AuthActions from '../LoginPage/reducer';

import * as services from './services';
import Creators, { SettingTypes as constants } from './reducer';

const actions = {
  getLanguagesListActions: {
    request: Creators.getLanguagesListRequest,
    success: Creators.getLanguagesListSuccess,
    errors: Creators.getLanguagesListFailure,
  },
  getNotificationsListActions: {
    request: Creators.getNotificationsListRequest,
    success: Creators.getNotificationsListSuccess,
    errors: Creators.getNotificationsListFailure,
  },

  changeNotificationsListActions: {
    request: Creators.changeNotificationsListRequest,
    success: Creators.changeNotificationsListSuccess,
    errors: Creators.changeNotificationsListFailure,
  },

  getSubscriptionsListActions: {
    request: Creators.getSubscriptionsListRequest,
    success: Creators.getSubscriptionsListSuccess,
    errors: Creators.getSubscriptionsListFailure,
  },
  cancelSubscriptionActions: {
    request: Creators.cancelSubscriptionRequest,
    success: Creators.cancelSubscriptionSuccess,
    errors: Creators.cancelSubscriptionFailure,
  },
  cancelSchedulingActions: {
    request: Creators.cancelSchedulingRequest,
    success: Creators.cancelSchedulingSuccess,
    errors: Creators.cancelSchedulingFailure,
  },
  addCompanyDetailsActions: {
    request: Creators.addCompanyDetailsRequest,
    success: Creators.addCompanyDetailsSuccess,
    errors: Creators.addCompanyDetailsFailure,
  },
  changeCompanyDetailsActions: {
    request: Creators.changeCompanyDetailsRequest,
    success: Creators.changeCompanyDetailsSuccess,
    errors: Creators.changeCompanyDetailsFailure,
  },
  changeBillingAddressActions: {
    request: Creators.changeBillingAddressRequest,
    success: Creators.changeBillingAddressSuccess,
    errors: Creators.changeBillingAddressFailure,
  },
  getPaymentsActions: {
    request: Creators.getPaymentsRequest,
    success: Creators.getPaymentsSuccess,
    errors: Creators.getPaymentsFailure,
  },
  changePaymentsActions: {
    request: Creators.changePaymentsRequest,
    success: Creators.changePaymentsSuccess,
    errors: Creators.changePaymentsFailure,
  },
  getPaymentsNextActions: {
    request: Creators.getPaymentsNextRequest,
    success: Creators.getPaymentsNextSuccess,
    errors: Creators.getPaymentsNextFailure,
  },
  getPaymentDetailsActions: {
    request: Creators.getPaymentDetailsRequest,
    success: Creators.getPaymentDetailsSuccess,
    errors: Creators.getPaymentDetailsFailure,
  },
  getUserCountryActions: {
    request: Creators.getUserCountryRequest,
    success: Creators.getUserCountrySuccess,
    errors: Creators.getUserCountryFailure,
  },
};

const eventsOptions = {
  [constants.GET_LANGUAGES_LIST_REQUEST]: {
    api: services.getLanguagesList,
    actions: actions.getLanguagesListActions,
  },
  [constants.GET_NOTIFICATIONS_LIST_REQUEST]: {
    api: services.getNotificationsList,
    actions: actions.getNotificationsListActions,
  },
  [constants.CHANGE_NOTIFICATIONS_LIST_REQUEST]: {
    api: services.changeNotificationsList,
    actions: actions.changeNotificationsListActions,
  },
  [constants.GET_SUBSCRIPTIONS_LIST_REQUEST]: {
    api: services.getSubscriptionsList,
    actions: actions.getSubscriptionsListActions,
  },
  [constants.CANCEL_SUBSCRIPTION_REQUEST]: {
    api: services.cancelSubscription,
    actions: actions.cancelSubscriptionActions,
  },
  [constants.CANCEL_SCHEDULING_REQUEST]: {
    api: services.cancelScheduling,
    actions: actions.cancelSchedulingActions,
  },
  [constants.ADD_COMPANY_DETAILS_REQUEST]: {
    api: services.addCompanyDetails,
    actions: actions.addCompanyDetailsActions,
  },
  [constants.CHANGE_COMPANY_DETAILS_REQUEST]: {
    api: services.addCompanyDetails,
    actions: actions.changeCompanyDetailsActions,
  },
  [constants.CHANGE_BILLING_ADDRESS_REQUEST]: {
    api: services.changeBillingAddress,
    actions: actions.changeBillingAddressActions,
  },
  [constants.GET_PAYMENTS_REQUEST]: {
    api: services.getPayments,
    actions: actions.getPaymentsActions,
  },
  [constants.CHANGE_PAYMENTS_REQUEST]: {
    api: services.changePayments,
    actions: actions.changePaymentsActions,
  },
  [constants.GET_PAYMENTS_NEXT_REQUEST]: {
    api: services.getPaymentsNext,
    actions: actions.getPaymentsNextActions,
  },
  [constants.GET_PAYMENT_DETAILS_REQUEST]: {
    api: services.getPaymentDetails,
    actions: actions.getPaymentDetailsActions,
  },
  [constants.GET_USER_COUNTRY_REQUEST]: {
    api: services.getUserCountry,
    actions: actions.getUserCountryActions,
  },
};

// const events = Object.keys(eventsOptions);

function* apiGenerator(action) {
  const provider = eventsOptions[action.type];

  try {
    const params = action.payload;
    const response = yield call(provider.api, params);

    if (response.data) {
      response.ok
        ? yield put(provider.actions.success(response.data))
        : yield put(provider.actions.errors({ errors: response.data }));

      if (response?.data?.user) {
        yield put(AuthActions.updateProfile({...response?.data?.user}));
      } else if(response?.data?.id && !['GET_USER_COUNTRY_REQUEST', 'GET_SUBSCRIPTIONS_LIST_REQUEST'].includes(action.type)) {
        yield put(AuthActions.updateProfile(response.data));
      }
    } else {
      yield put(provider.actions.errors({ errors: 'some error' }));
    }
  } catch (errors) {
    yield put(provider.actions.errors({ errors }));
  }
}

export default function* apiSaga() {
  yield takeLatest(constants.GET_LANGUAGES_LIST_REQUEST, apiGenerator);
  yield takeLatest(constants.GET_NOTIFICATIONS_LIST_REQUEST, apiGenerator);
  yield takeLatest(constants.CHANGE_NOTIFICATIONS_LIST_REQUEST, apiGenerator);
  yield takeLatest(constants.GET_SUBSCRIPTIONS_LIST_REQUEST, apiGenerator);
  yield takeLatest(constants.CANCEL_SUBSCRIPTION_REQUEST, apiGenerator);
  yield takeLatest(constants.CANCEL_SCHEDULING_REQUEST, apiGenerator);
  yield takeLatest(constants.ADD_COMPANY_DETAILS_REQUEST, apiGenerator);
  yield takeLatest(constants.CHANGE_COMPANY_DETAILS_REQUEST, apiGenerator);
  yield takeLatest(constants.GET_PAYMENTS_REQUEST, apiGenerator);
  yield takeLatest(constants.CHANGE_PAYMENTS_REQUEST, apiGenerator);
  yield takeLatest(constants.GET_PAYMENTS_NEXT_REQUEST, apiGenerator);
  yield takeLatest(constants.CHANGE_BILLING_ADDRESS_REQUEST, apiGenerator);
  yield takeLatest(constants.GET_PAYMENT_DETAILS_REQUEST, apiGenerator);
  yield takeLatest(constants.GET_USER_COUNTRY_REQUEST, apiGenerator);
}
